<ngx-daterangepicker-material
[singleDatePicker]="single" 
[autoApply]="true" 
ngxDaterangepickerMd 
[locale]="dateOptions" 
(choosedDate)="select($event);">
</ngx-daterangepicker-material>